module.exports = __webpack_public_path__ + "img/time-glass.8c12c7eb.png";